import $ from "jquery";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import { Toolbar } from "@fancyapps/ui/dist/carousel/carousel.toolbar";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "@fancyapps/ui/dist/carousel/carousel.toolbar.css";
import Player from "@vimeo/player";

let player;

$(document).on('click', '.videoContainer', function (e) {
    e.preventDefault();
    const normalVideoUrl = $(this).data('src');
    const mirroredVideoUrl = $(this).data('mirrored');
    Fancybox.show(
        [
            {
                src: normalVideoUrl,
            }
        ],
        {
            Hash: {
                slug: "video",
            },
            backdropClick: false,
            dragToClose: false,
            Carousel: {
                Video: {
                    //autoplay: false,
                },
                Toolbar: {
                    enabled: true,
                    absolute: true,
                    display: {
                        left: [],
                        middle: [mirroredVideoUrl ? "switchView" : null],
                        right: ["close"],
                    },
                    items: {
                        switchView: {
                            tpl: `
                                <button class="f-button f-button--switch" title="Switch view" data-off="Mirror mode: OFF" data-on="Mirror mode: ON">
                                    <svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"></path></svg>
                                </button>`,
                            click: function (instance, event) {
                                const buttonEl = event.currentTarget;
                                const currentSlide = Fancybox.getSlide();
                                buttonEl.classList.toggle('active');
                                currentSlide.el.classList.add('switching-view');
                                buttonEl.setAttribute('disabled', 'true');

                                // 1. Manually check for/append the native Fancybox 6 spinner component
                                let spinner = currentSlide.el.querySelector('.f-spinner');
                                if (!spinner) {
                                    spinner = document.createElement('div');
                                    spinner.className = 'f-spinner';
                                    // Append inside the slide main wrapper, outside the iframe content box
                                    currentSlide.el.appendChild(spinner);
                                }
                                let language_code;
                                player.getTextTracks().then(function (tracks) {
                                    tracks.forEach( (element) => { element.mode === 'showing' ? language_code = element.language : false });
                                    player.getCurrentTime().then(function (seconds) {
                                        player.loadVideo( !buttonEl.classList.contains('active') ? normalVideoUrl : mirroredVideoUrl ).then(function (id) {
                                            player.setCurrentTime(seconds).then(function (seconds) {
                                                language_code ? player.enableTextTrack(language_code) : false;
                                                currentSlide.el.classList.remove('switching-view');
                                                if (spinner) spinner.remove();
                                                buttonEl.removeAttribute('disabled');
                                                player.play();
                                            });
                                        });
                                    });
                                });
                            }
                        }
                    }
                },
            },
            on: {
                ready: () => {
                    const slide = Fancybox.getSlide();
                    const iframe = slide.el.querySelector('iframe');
                    player = new Player(iframe);

                    let totalSeconds = 0;
                    let prevSeconds = 0;

                    player.on('play', function (data) {
                        prevSeconds = data.seconds;
                    });
                    player.on('seeked', function (data) {
                        prevSeconds = data.seconds;
                    });

                    /*player.on('timeupdate', function (data) {
                      setTimeout(function () {
                        if ( prevSeconds >= data.seconds || data.seconds - prevSeconds > 1 ) return;
                        totalSeconds = totalSeconds + data.seconds - prevSeconds;
                        prevSeconds = data.seconds;
                        if ( totalSeconds >= 60 ) {
                          $.post({
                            data: {
                              action: 'track_watching_time',
                              post_id: bellystream.post_id,
                              seconds: Math.round(totalSeconds)
                            }
                          });
                          totalSeconds = 0;
                        }
                      },100)
                    });*/
                }
            }
        }
    );
});